import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import {VenIndexComponent} from "../section-oadr/ven/ven-index/ven-index.component";
import {EventIndexComponent} from "../section-event/event/event-index/event-index.component";

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [RouterModule, CommonModule, FormsModule, NgxPaginationModule, VenIndexComponent, EventIndexComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {}
